"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SharedCollectionContext = void 0;
const shared_store_reader_1 = require("../shared-store-reader");
const shared_values_context_1 = require("./shared-values-context");
const immer_1 = require("immer");
class SharedCollectionContext {
    constructor(store) {
        this.store = store;
    }
    get(key, valueKeyOrKeys) {
        const collection = this.getCollection(key);
        if (Array.isArray(valueKeyOrKeys)) {
            return shared_store_reader_1.getValuesFromCollection(collection, key, valueKeyOrKeys);
        }
        else {
            return shared_store_reader_1.getCollectionValue(collection, key, valueKeyOrKeys);
        }
    }
    getAll(key) {
        const collection = this.getCollection(key);
        const keys = collection.allKeys();
        return shared_store_reader_1.getValuesFromCollection(collection, key, keys);
    }
    waitFor(key, valueKey, criteria) {
        if (!valueKey)
            throw Error(`Attempt to wait for an undefined value key for ${key.id}`);
        const collection = this.getCollection(key);
        const value = shared_store_reader_1.getCollectionValue(collection, key, valueKey);
        if (shared_values_context_1.valueMeetsCriteria(value, criteria))
            return Promise.resolve(value);
        else
            return shared_values_context_1.waitForUpdate(collection, valueKey, criteria);
    }
    changes(key, valueKeyOrKeys) {
        const collection = this.getCollection(key);
        return collection.onChange(valueKeyOrKeys);
    }
    anyChanges(key) {
        const collection = this.getCollection(key);
        return collection.onAnyChange();
    }
    set(key, valueKey, value) {
        if (valueKey) {
            const { resolver } = key;
            const collection = this.getCollection(key);
            collection.setValue(valueKey, value);
            if (resolver)
                resolver.valuesChanged({ [valueKey]: value });
        }
        else {
            console.warn(`Attempt to set a value for undefined value key in ${key.id}`);
        }
    }
    modify(key, valueKey, modify) {
        const current = this.get(key, valueKey);
        const newValue = immer_1.produce(current, modify);
        this.set(key, valueKey, newValue);
    }
    modifyAll(key, modify) {
        const collection = this.getCollection(key);
        const keys = collection.allKeys();
        const update = {};
        for (const key of keys) {
            const current = collection.getValue(key);
            update[key] = immer_1.produce(current, modify);
        }
        this.update(key, update);
    }
    update(key, update) {
        const { resolver } = key;
        const collection = this.getCollection(key);
        collection.update(update);
        if (resolver)
            resolver.valuesChanged(update);
    }
    delete(key, valueKey) {
        if (valueKey) {
            const { resolver } = key;
            const collection = this.getCollection(key);
            const keys = Array.isArray(valueKey) ? valueKey : [valueKey];
            collection.delete(keys);
            if (resolver)
                resolver.valuesRemoved(keys);
        }
        else {
            console.warn(`Trying to delete an undefined value key in ${key.id}`);
        }
    }
    clear(key) {
        const { resolver } = key;
        const collection = this.getCollection(key);
        const keys = collection.allKeys();
        if (keys && keys.length > 0) {
            collection.delete(keys);
        }
        if (resolver)
            resolver.valuesRemoved(keys);
    }
    getCollection(key) {
        return shared_store_reader_1.getSharedValue(this.store, key);
    }
}
exports.SharedCollectionContext = SharedCollectionContext;
//# sourceMappingURL=shared-collection-context.js.map